module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ../node_modules/normalize-wheel/index.js
// module id = TW9E
// module chunks = 0